import * as React from "react";
import type { SVGProps } from "react";
const LtIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="m7.192 11.316 10-4.5.616 1.368L9.328 12l8.48 3.816-.616 1.368-10-4.5a.75.75 0 0 1 0-1.368" clipRule="evenodd" /></svg>;
export default LtIcon;